import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GoogleOnetapLoginComponent } from './common/google-onetap-login/google-onetap-login.component';
import { ErrorHandlerModule } from './error-handler/error-handler.module';
import { HttpInterService } from '@services/http-inter/http-inter.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'my-app' }),
    NgtUniversalModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('/new/ngsw-worker.js', {
      enabled: true,
      scope: '/new/',
      registrationStrategy: 'registerWhenStable:30000'
    }),
    HttpClientModule,
    MatBottomSheetModule,
    MatDialogModule,
    MatSnackBarModule,
    AppRoutingModule,
    ErrorHandlerModule,
    GoogleOnetapLoginComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterService,
      multi: true
    },
    // Global fallbacks so dialog components can also render inline (routed/embedded).
    // Previously provided by the removed ModuleLoaderModule; real dialogs override these.
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
